import { Fragment } from 'react';
import { Box, TextInput } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { FormSubmitButton } from './FormSubmitButton';
export function SimpleTextField() {
    const [field, meta] = useField('value');
    const error = Boolean(meta.touched && meta.error);
    return (<Fragment>
      <Box mt="sm" mx="sm">
        <TextInput stretch {...field} invalid={error}/>
      </Box>
      <FormSubmitButton />
    </Fragment>);
}
